import { FieldDefinition, FieldBuilder, MenuCategories, MenuSubcategories, MENU_CATEGORY_KEY, MENU_SUBCATEGORY_KEY, MENU_NAME_SUFFIX } from '@zendra/shared';

FieldBuilder.setNamespace('General');

export const REMSOFTSPECIESGROUP_FIELDS: FieldDefinition[] = [
  FieldBuilder
    .text('name', 'Entity.RemsoftSpeciesGroup.Name')
    .required()
    .maxLength(200)
    .build(),
  FieldBuilder
    .text('code', 'Entity.RemsoftSpeciesGroup.Code')
    .required()
    .maxLength(10)
    .build(),
];

export const REMSOFTSPECIESGROUP_CONFIG = {
  entityName: 'RemsoftSpeciesGroup',
  localizationKey: 'General::Entity.RemsoftSpeciesGroup',
  fields: REMSOFTSPECIESGROUP_FIELDS,
  permission: 'ResearchAndDevelopmentGeneticMaterial.RemsoftSpeciesGroups',
  showInMenu: true,
  menuCategory: MENU_CATEGORY_KEY + MenuCategories.ResearchAndDevelopment + MENU_NAME_SUFFIX,
  menuSubcategory: MENU_SUBCATEGORY_KEY + MenuSubcategories.GeneticMaterial + MENU_NAME_SUFFIX,
};
